import { Alert, IconButton, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideNotification, selectNotification } from "./notificationSlice";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const LassoNotification = () => {
    const dispatch = useDispatch();
    const notification = useSelector(selectNotification);

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(hideNotification());
    };

    const action = (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
        >
            <CloseIcon fontSize="small"/>
        </IconButton>
    );

    return (
        <>
            <Snackbar
                open={notification.isDisplayed && notification.message?.length > 0}
                autoHideDuration={3000}
                onClose={handleClose}
                action={action}
            >
                <Alert
                    onClose={handleClose}
                    severity={notification.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default LassoNotification;